export {
  External,
  Flag,
  Location,
  Vocabulary,
  Star,
  Hamburger,
  DragHandleMinor,
} from './Svg';
